import React, { useState } from "react";
import ReactDOM from "react-dom";
import logger from "../../services/Logger";
import { sendSMS } from "../../services/Notifications";
import "./TextAgent.css";

export default function TextAgent({ number, arrivalTime, address }) {
  const [showDialog, setShowDialog] = useState(false);
  const [message, setMessage] = useState("");

  // Opens the dialog with default message
  const openMessageDialog = () => {
    // Set initial default message
    setMessage(`Agent would like to visit ${address} at ${arrivalTime}`);
    setShowDialog(true);
  };

  // Handles message text changes
  const handleMessageChange = (e) => {
    setMessage(e.target.value);
  };

  // Sends the message and closes the dialog
  const sendTextMessageToNumber = () => {
    logger.info("sending a text message to - ", number);
    sendSMS(number, message);
    setShowDialog(false);
  };

  // Cancels sending and closes the dialog
  const cancelSending = () => {
    setShowDialog(false);
  };

  // Render the dialog using a portal to place it at the root DOM level
  const renderDialog = () => {
    if (!showDialog) return null;

    return ReactDOM.createPortal(
      <div className="text-dialog-overlay" onClick={cancelSending}>
        <div className="text-dialog" onClick={(e) => e.stopPropagation()}>
          <h3>Edit Message</h3>
          <p>Sending to: {number}</p>

          <textarea className="text-message-input" value={message} onChange={handleMessageChange} rows={4} />

          <div className="text-dialog-buttons">
            <button onClick={cancelSending}>Cancel</button>
            <button onClick={sendTextMessageToNumber}>Send</button>
          </div>
        </div>
      </div>,
      document.body // Mount the portal directly to the body element
    );
  };

  return (
    <div className="text-agent-container">
      <div className="text-agent-button-container">
        The agent is asking to get a text when you are going
        <button className="text-agent-button" onClick={openMessageDialog}>
          Send text
        </button>
      </div>

      {/* Render dialog through portal */}
      {renderDialog()}
    </div>
  );
}
